import { render, staticRenderFns } from "./passengerList.vue?vue&type=template&id=c1f6ccec&scoped=true&"
import script from "./passengerList.vue?vue&type=script&lang=js&"
export * from "./passengerList.vue?vue&type=script&lang=js&"
import style0 from "./passengerList.vue?vue&type=style&index=0&id=c1f6ccec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1f6ccec",
  null
  
)

export default component.exports